<a
  [routerLink]="['./', 'tournament', tournamentId]"
  type="button"
  class="btn btn-primary"
  ><fa-icon [icon]="faEdit" title="Edit"></fa-icon
></a>
